import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import Cookie from 'js-cookie'

import WorkSpace from '../components/WorkSpace/WorkSpace'
import Controls from '../components/Controls/Controls'
import Download from '../components/Download/Download'

import { updateSettingsIds } from '../store/actions/settings.actions'

import { initMetrics } from '../helpers/initMetrics'
import { sendMetric } from '../helpers/metric'
import ProjectMenu from '../components/ProjectMenu/ProjectMenu'
import Nav from '../components/Nav/Nav'
import StateControls from '../components/StateControls/StateControls'
import Logo from '../components/Logo/Logo'
import PrevProjectRestoration from '../components/PrevProjectRestoration/PrevProjectRestoration'

class App extends Component {
  static propTypes = {
    settingsList: PropTypes.array.isRequired,
    currentSettingId: PropTypes.number.isRequired,
    updateSettingsIds: PropTypes.func.isRequired,
    imageStatus: PropTypes.bool.isRequired,
    i18n: PropTypes.any,
    t: PropTypes.any,
  }

  state = {
    dropzoneRef: null,
    isChangesModalOpen: false,
  }

  componentDidMount() {
    const { i18n } = this.props
    if (i18n.language === 'ru') {
      initMetrics(process.env.REACT_APP_GTM_RU_ID, this.sendAnalitics)
    } else {
      initMetrics(process.env.REACT_APP_GTM_ENG_ID, this.sendAnalitics)
    }
  }

  sendAnalitics = () => {
    const hasCookie = !!Cookie.get('peo_first_start')
    const timeStamp = Date.now().toString()
    const referrerUrl = document.referrer || 'direct_move'
    if (!hasCookie) {
      Cookie.set('peo_first_start', timeStamp, { expires: 3650 })
    }

    sendMetric({
      event: hasCookie ? 'EVERY_START' : 'FIRST_START',
      amplitude: {
        URL: referrerUrl
      }
    })
  }

  forwardDropzoneRef = (element) => {
    this.setState({ dropzoneRef: element })
  }

  openFileDialog = () => {
    const { dropzoneRef } = this.state
    const { imageStatus } = this.props

    if (imageStatus) {
      this.setState({ isChangesModalOpen: imageStatus })
      return
    }
    if (dropzoneRef) dropzoneRef.open()
  }

  onChangesModalClose = (shouldProceed = false) => {
    const { dropzoneRef } = this.state
    this.setState({ isChangesModalOpen: false })

    if (shouldProceed && dropzoneRef) {
      dropzoneRef.open()
    }
  }

  onOpenNew = () => {
    const { dropzoneRef } = this.state

    if (dropzoneRef) {
      dropzoneRef.open()
    }
  }

  render() {
    const {
      isChangesModalOpen,
    } = this.state
    const { t } = this.props

    return (
      <div className="app">
        <Helmet>
          <title>{t('meta.title')}</title>
          <meta name="description" content="Todos on steroid!" />
          <meta name="theme-color" content="#008f68" />
        </Helmet>
        <PrevProjectRestoration onOpenNew={this.onOpenNew} />
        <header>
          <Logo />
          <ProjectMenu openFileDialog={this.openFileDialog} />
        </header>
        <aside>
          <Nav />
          <Controls />
        </aside>
        <main>
          <WorkSpace forwardDropzoneRef={this.forwardDropzoneRef} openFileDialog={this.openFileDialog} />
        </main>
        <footer>
          <StateControls />
          <Download isChangesModalOpen={isChangesModalOpen} onChangesModalClose={this.onChangesModalClose} />
        </footer>
      </div>
    )
  }
}

const mapStateToProps = ({
  settingsStore: {
    settingsList,
    currentSettingId,
    imageStatus
  },
}) => ({
  settingsList,
  currentSettingId,
  imageStatus,
})
const mapDispatchToProps = (dispatch) => ({
  updateSettingsIds: (id) => dispatch(updateSettingsIds(id)),
})

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
)
